import React, { useState, useEffect } from "react";
import { Card } from "../../../../common";
import { KeyPersonnelItem } from "./KeyPersonnelItem";

export const KeyPersonnel = ({ companyKeyPersonnel }) => {
  const [keyPersonnel, setKeyPersonnel] = useState([]);

  function addColorKey(personnelArray) {
    return personnelArray.map((personnel) => {
      const newPersonnel = { ...personnel };
      newPersonnel.key_personnelID = { ...personnel.key_personnelID };

      if (newPersonnel.key_personnelID.designation === "CEO") {
        newPersonnel.key_personnelID.color = "#EB3379";
      } else if (newPersonnel.key_personnelID.designation === "COO") {
        newPersonnel.key_personnelID.color = "#44B2B3";
      } else if (newPersonnel.key_personnelID.designation === "CTO") {
        newPersonnel.key_personnelID.color = "#FCB316";
      } else if (newPersonnel.key_personnelID.designation === "CMO") {
        newPersonnel.key_personnelID.color = "#FF00CF";
      } else if (newPersonnel.key_personnelID.designation === "CSO") {
        newPersonnel.key_personnelID.color = "#FF80DF";
      } else {
        newPersonnel.key_personnelID.color = "#FF80DF";
      }

      return newPersonnel;
    });
  }

  useEffect(() => {
    if (Array.isArray(companyKeyPersonnel)) {
      const updatedData = addColorKey(companyKeyPersonnel);
      setKeyPersonnel(updatedData);
    }
  }, []);

  const tabs = [
    {
      title: "Sheikh Zayed ",
      designation: "CEO",
      content: "Content for Tab 1",
      value: 10,
      color: "#EB3379",
    },
    {
      title: "Latifa Rashid",
      designation: "COO",
      content: "Content for Tab 3",
      value: 20,
      color: "#44B2B3",
    },
    {
      title: "Latifa Rashid 4",
      designation: "CTO",
      content: "Content for Tab 4",
      value: 30,
      color: "#FCB316",
    },
    {
      title: "Latifa Rashid 5",
      designation: "CFO",
      content: "Content for Tab 5",
      value: 20,
      color: "#6B3372",
    },
    {
      title: "Latifa Rashid 6",
      designation: "CMO",
      content: "Content for Tab 6",
      value: 10,
      color: "#FF00CF",
    },
    {
      title: "Latifa Rashid 7",
      designation: "CSO",
      content: "Content for Tab 7",
      value: 10,
      color: "#FF80DF",
    },
  ];

  return (
    <Card classes="hidden sm:block rounded-xl bg-white p-6 mb-6">
      <h4 className="text-f18 text-primary mb-4 font-semibold text-left">
        Key Personnel
      </h4>
      <div className="rounded-xl ">
        <table class="w-full text-left border border-b border-slate rounded">
          <thead class="text-secondarytwo border border-b border-slate text-f14">
            <tr>
              <th scope="col" class="px-6 py-3">
                Name
              </th>
              <th scope="col" class="px-6 py-3">
                Designation
              </th>
              <th scope="col" class="px-6 py-3">
                Work Mobile No.
              </th>
              <th scope="col" class="px-6 py-3">
                Work Email Address
              </th>
            </tr>
          </thead>
          <tbody>
            {keyPersonnel.map((keyPersonnel) => (
              <KeyPersonnelItem
                key={keyPersonnel.value}
                keyPersonnel={keyPersonnel}
              />
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
};
